export type NotificationType =
    | "registration_created"
    | "registration_cancelled"
    | "registration_updated"
    | "registration_removed";

export interface AppNotification {
    id: string;
    user_id: string;
    type: NotificationType;
    title: string;
    body: string | null;
    /** In-app route to open, e.g. /admin/events/<id>/registrations. */
    link: string | null;
    event_id: string | null;
    registration_id: string | null;
    read_at: string | null;
    created_at: string;
}

export const NOTIFICATION_ICONS: Record<NotificationType, string> = {
    registration_created: "person_add",
    registration_cancelled: "person_remove",
    registration_updated: "edit_note",
    registration_removed: "event_busy",
};
